import RichText from 'components/UI/Richtext';
import { ReactElement } from 'react';
import { IComponentIFrameFields } from 'types/contentful';

export default function IFrame({
  iframeScript,
  hasBackgroundColor,
  heading,
}: IComponentIFrameFields): ReactElement {
  return (
    <div
      className={`flex flex-col py-10 md:py-20 px-site-component ecp-my ${
        hasBackgroundColor ? 'bg-muted' : ''
      }`}
    >
      {heading && (
        <RichText
          document={heading}
          classNames="font-light text-2xl md:text-4xl mb-4 text-center text-primary-actual iframe-richtext"
        />
      )}
      <div className="w-full mx-auto" dangerouslySetInnerHTML={{ __html: iframeScript }} />
    </div>
  );
}
